import { render, staticRenderFns } from "./contentLectureDocument.vue?vue&type=template&id=2a4baf77&"
import script from "./contentLectureDocument.vue?vue&type=script&lang=js&"
export * from "./contentLectureDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports